/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { cloneDeep, isEmpty } from 'lodash';

// Components
import DropdownMenu from 'shared/ui/components/DropdownMenu.vue';
import GenericDocExternalPicker from 'shared/ui/components/form-components/pickers/GenericDocExternalPicker.vue';
import InputWithActions from 'shared/ui/components/form-components/InputWithActions.vue';
import SearchBar from 'shared/ui/components/form-components/SearchBar.vue';

const __vue_script__ = {
    name: 'SessionGroups',

    components: { DropdownMenu, GenericDocExternalPicker, InputWithActions, SearchBar },

    props: {
        event: {
            type: Object,
            required: true
        },

        value: {
            type: Array,
            required: true
        },

        disabled: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            innerValue: [],
            collapsedGroups: [],
            editing: false,
            title: '',
            searchTerm: ''
        };
    },

    computed: {
        visibleGroups() {
            return this.innerValue.filter(group => this.searchTerm === '' || group.title.toLowerCase().includes(this.searchTerm.toLowerCase()));
        }
    },

    watch: {
        value: {
            deep: true,
            immediate: true,
            handler(groups) {
                this.innerValue = cloneDeep(groups);

                const last = this.innerValue[this.innerValue.length - 1];

                if (last?.new) {
                    this.rename(this.innerValue.length - 1);
                }
            },
        }
    },

    methods: {
        /**
         * Toggles the specified group
         *
         * @param {string} group the group name to toggle
         */
        toggleGroup(group) {
            if (this.collapsedGroups.includes(group)) {
                this.collapsedGroups = this.collapsedGroups.filter(s => s !== group);
            } else {
                this.collapsedGroups.push(group);
            }
        },

        /**
         * Starts the group name editing
         *
         * @param {number} index the group index to edit
         */
        rename(index) {
            this.title = this.innerValue[index].title;
            this.editing = index;
        },

        /**
         * Removes the group from the list
         *
         * @param {number} index the index of the group to remove
         * @emits input
         */
        removeGroup(index) {
            /** @type {object[]} */
            const groups = this.innerValue;
            const group = groups[index];

            if (!group) {
                console.warn('[SessionGroups] Specified group does not exist', index);
                return;
            }

            groups.splice(index, 1);
            this.emit();
        },

        /**
         * Stops the editing of the group title
         */
        stopTitleEditing(index) {
            this.title = '';
            this.editing = -1;

            if (this.innerValue[index].new) {
                delete this.innerValue[index].new;

                if (isEmpty(this.innerValue[index].title)) {
                    this.removeGroup(index);
                }
            }
        },

        /**
         * Sets the title for the group at index
         *
         * @param {number} index the index of the group
         */
        setTitle(index) {
            this.$set(this.innerValue[index], 'title', this.title);
            this.stopTitleEditing(index);
            this.emit();
        },

        /**
         * Emits the change event to the parent with the
         * current values.
         *
         * @emits change
         */
        change() {
            if (!this.disabled) {
                this.$emit('change', this.innerValue);
            }
        },

        /**
         * Emits an event.
         * @emits input
         */
        emit() {
            this.$emit('input', this.innerValue);
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{ref:"form",attrs:{"slim":true},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var handleSubmit = ref.handleSubmit;
return [_c('form',{staticClass:"session-groups",attrs:{"autocomplete":"off"},on:{"submit":function($event){$event.preventDefault();return handleSubmit(_vm.change)}}},[_vm._t("intro"),_c('div',{staticClass:"heading"},[_vm._t("top-header"),_c('search-bar',{attrs:{"show-no-result":false},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}})],2),(_vm.innerValue.length === 0)?_c('div',{staticClass:"empty-state"},[_vm._t("empty")],2):_vm._e(),_vm._l((_vm.visibleGroups),function(group,index){return (_vm.visibleGroups.length > 0)?_c('div',{key:((group.type) + "-" + index),staticClass:"group",class:{collapsed: _vm.collapsedGroups.includes(index)}},[(_vm.editing !== index)?_c('div',{staticClass:"title-and-actions"},[_c('div',{staticClass:"actions"},[_c('span',{staticClass:"small count"},[_vm._v(_vm._s(_vm.$tc('registration.configuration.session_groups_count', group.fp_ext_ids.length, [group.fp_ext_ids.length])))]),_c('a',{staticClass:"toggler",on:{"click":function($event){return _vm.toggleGroup(index)}}},[_c('i',{staticClass:"ic-chevron-up"})]),_c('dropdown-menu',{staticClass:"embedded"},[_c('ul',[_c('li',[_c('a',{staticClass:"has-action rename",on:{"click":function($event){$event.preventDefault();return _vm.rename(index)}}},[_c('i',{staticClass:"ic-edit"}),_vm._v(_vm._s(_vm.$t('registration.configuration.actions.rename')))])]),_c('li',[_c('a',{staticClass:"has-action delete danger",on:{"click":function($event){$event.preventDefault();return _vm.removeGroup(index)}}},[_c('i',{staticClass:"ic-trash-2"}),_vm._v(_vm._s(_vm.$t('registration.configuration.actions.remove')))])])])])],1),(group.title)?_c('span',{staticClass:"title"},[_vm._v(_vm._s(group.title))]):_c('span',{staticClass:"title empty"},[_vm._v(_vm._s(_vm.$t('registration.configuration.no_title_set')))])]):_c('div',{staticClass:"title-and-actions editing"},[_c('validation-provider',{attrs:{"slim":true,"name":"title"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('input-with-actions',{attrs:{"type":"text","name":"title","autofocus":true,"placeholder":_vm.$t('registration.configuration.new_sessions_group_placeholder'),"errors":errors},model:{value:(_vm.title),callback:function ($$v) {_vm.title=$$v},expression:"title"}},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.stopTitleEditing(index)}}},[_vm._v(_vm._s(_vm.$t('general.cancel')))]),_c('button',{staticClass:"btn btn-success",attrs:{"type":"button"},on:{"click":function($event){return _vm.setTitle(index)}}},[_vm._v(_vm._s(_vm.$t('general.accept')))])])]}}],null,true)})],1),(!group.new)?_c('div',{staticClass:"group-config"},[_c('validation-provider',{attrs:{"rules":"required","slim":true,"skip-if-empty":false,"mode":"passive","name":_vm.$t('registration.activation.messages.sessions_field')},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('generic-doc-external-picker',{attrs:{"fp-type":"session","name":("ext-" + index),"event-id":_vm.event._id,"timezone":_vm.event.timezone,"placeholder":_vm.$t('registration.configuration.form.placeholders.session'),"multiple":true,"sortable":false,"errors":errors},on:{"input":_vm.emit},model:{value:(group.fp_ext_ids),callback:function ($$v) {_vm.$set(group, "fp_ext_ids", $$v)},expression:"group.fp_ext_ids"}})]}}],null,true)})],1):_vm._e()]):_vm._e()}),_c('secondary-toolbar',[_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.disabled}},[_vm._v(_vm._s(_vm.$t('general.save')))])])],2)]}}],null,true)})}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "SessionGroups.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__